module.exports = __webpack_public_path__ + "ath_game_web/img/9.1.70c139c1.png";